import VwKimlikDTO from "src/models/Genel/VwKimlikDTO";
import api from "../core/api";
import GnlParametreGrupDTO from "src/models/GnlParametre/GnlparametregrupDTO";
import GnlMailOntanimlarDTO from "src/models/Mail/GnlMailOntanimlarDTO";
import MailRequest from "src/models/Mail/MailRequest";
import OrganizasyonMailDTO from "src/models/Mail/OrganizasyonMailDTO";
import VwPatolojiRaporMailGonderimDTO from "src/models/PatolojiModul/VwPatolojiRaporMailGonderimDTO";
import { ApiRequest } from "src/models/api.request";
import { ApiResponse } from "../core";
import VwPatolojiRaporislemleriDTO from "src/models/PatolojiModul/VwPatolojiRaporislemleriDTO";

const controllerName = "OrganizasyonMail";

export const OrganizasyonMailApi = api.injectEndpoints({
    endpoints: (builder) => ({
        organizasyonMailGetir: builder.query<OrganizasyonMailDTO, {
            organizasyonId: number
        }>({
            query: (request) => ({
                url: controllerName + "/OrganizasyonMailGetir",
                method: "GET",
                params: request
            })
        }),
        organizasyonMailGuncelle: builder.mutation<boolean, OrganizasyonMailDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/OrganizasyonMailGuncelle",
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["ParametreTanim"]
        }),
        sendMailMessage: builder.query<boolean, {
            organizasyonId: number,
            mailRequest: MailRequest
        }>({
            query: (request) => {
                return {
                    url: controllerName + "/SendMailMessage",
                    method: "POST",
                    body: JSON.stringify(request.mailRequest),
                    params: {
                        organizasyonId: request.organizasyonId
                    }
                }
            },
        }),
        gnlMailOntanimlarGetir: builder.query<Array<GnlMailOntanimlarDTO>, {
            organizasyonId: number
        }>({
            query: (request) => {
                return {
                    url: controllerName + "/GnlMailOntanimlarGetir",
                    method: "GET",
                    params: request
                }
            },
        }),
        gnlMailOntanimlarEkle: builder.mutation<GnlMailOntanimlarDTO, GnlMailOntanimlarDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/GnlMailOntanimlarEkle",
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
        }),
        gnlMailOntanimlarGuncelle: builder.mutation<boolean, GnlMailOntanimlarDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/GnlMailOntanimlarGuncelle",
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            },
        }),
        HastaMailGetir: builder.query<VwKimlikDTO, {
            kimlikId: number
        }>({
            query: (request) => {
                return {
                    url: controllerName + "/HastaMailGetir",
                    method: "GET",
                    params: request
                }
            },
        }),
    })
});

export const {
    useOrganizasyonMailGetirQuery,
    useOrganizasyonMailGuncelleMutation,
    useLazySendMailMessageQuery,
    useGnlMailOntanimlarGetirQuery,
    useGnlMailOntanimlarEkleMutation,
    useGnlMailOntanimlarGuncelleMutation,
    useHastaMailGetirQuery,
} = OrganizasyonMailApi;